/**
 * 
 */
export class PaymentInfo {
  // public 変数 ------------------------------------------------------------------------
  public tokenNo:		string = null;    // トークン番号
  public paymentType:	string = null;    // 支払種別
  public paymentMethod:	string = null;    // 支払方法
  public cardType:		string = null;    // カード種別
  public cardHolder:	string = null;    // カード名義人
  public cardNo: string = null;
  public orderId: string = null;
  // -------------------------------------------------------------------------------------
}
